import React from 'react'; 
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { Login, Home, Profile, Campaign, GameRoom, Lobby, Learn, Forum } from './pages';

class App extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/home" component={Home} />
            <Route path="/profile" component={Profile} />
            <Route path="/campaign" component={Campaign} />
            {/* <Route path="/dojo" component={Dojo} /> */}
            <Route path="/learn" component={Learn} />
            {/* <Route path="/editor" component={Editor} /> */}
            <Route path="/forum" component={Forum} />
            <Route
              path="/lobby"
              render={(props) => {
                return <Lobby {...props} />
              }}
            />
            <Route
              path="/:id"
              render={(props) => {
                if (props.match.url !== '/lobby') {
                  return <GameRoom key={props.location.key} {...props} />
                }
              }}
            />
          </Switch>
        </Router>
      </div>
    )
  }
}

export default App;